module.exports = __webpack_public_path__ + "static/media/NIFTYAUTO.fde18548.txt";